/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungDto } from '../../models/buchung-dto';
import { CreateBuchungDto } from '../../models/create-buchung-dto';

export interface CreateBuchungForMitarbeiter$Json$Params {

/**
 * ID des Mitarbeiters
 */
  mitarbeiterId: string;
  
    /**
     * Daten für die Buchung
     */
    body?: CreateBuchungDto
}

export function createBuchungForMitarbeiter$Json(http: HttpClient, rootUrl: string, params: CreateBuchungForMitarbeiter$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<BuchungDto>> {
  const rb = new RequestBuilder(rootUrl, createBuchungForMitarbeiter$Json.PATH, 'post');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BuchungDto>;
    })
  );
}

createBuchungForMitarbeiter$Json.PATH = '/v1/mitarbeiter/{mitarbeiterId}/buchungen';
